import {Badge, Drawer, List, Skeleton} from "antd";
import React, {useEffect, useState} from "react";
import {FaAngleDoubleDown, FaAngleDoubleUp, FaBell, FaCheck, FaInfo, FaPlus} from "react-icons/fa";
import classes from "./NotificationPanel.module.scss";
import {useDispatch, useSelector} from "react-redux";
import {getNotifications, getNotViewedNotificationsCount, update} from "../../../store/actions";
import ScrollContainer from "react-indiana-drag-scroll";
import {setFullShow} from "../../../store/actions";

const PAGE_SIZE = 15;
const throttleDelay = 100;
export const MAX_NOTIFICATION_MESSAGE_LENGTH = 70;

const NotificationsPanel = () => {
    const dispatch = useDispatch();
    const [notificationsOpen, setNotificationsOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const loading = useSelector((state) => state.notifications.loading);
    const notifications = useSelector((state) => state.notifications.list);
    const notificationCount = useSelector((state) => state.notifications.totalCount);
    const hasNext = useSelector((state) => state.notifications.hasNext);

    let throttleTimer = null;

    useEffect(() => {
        dispatch(getNotViewedNotificationsCount());
        dispatch(getNotifications(currentPage, PAGE_SIZE));
    }, []);

    useEffect(() => {
        const handleScrollBottom = (event) => {
            if (notificationsOpen && hasNext) {
                const {scrollHeight, scrollTop, clientHeight} = event.target;

                clearTimeout(throttleTimer);
                throttleTimer = setTimeout(() => {
                    if (Math.abs(scrollHeight - clientHeight - scrollTop) <= 1) {
                        dispatch(getNotifications(currentPage + 1, PAGE_SIZE));
                        setCurrentPage(currentPage + 1);
                    }
                }, throttleDelay);
            }
        };

        const node = document.querySelector(".ant-drawer-body");

        if (node) {
            node.addEventListener("scroll", handleScrollBottom);
        }

        return () => {
            if (node) {
                node.removeEventListener("scroll", handleScrollBottom);
            }
        };
    });

    //update notifications and reset to first page
    const onClose = () => {
        setNotificationsOpen(false);
        setCurrentPage(0);
        dispatch(update(notifications, PAGE_SIZE));
    };

    const getIconByItem = (item) => {
        switch (item.type) {
            case "INFO": {
                return <FaInfo size={13}/>
            }
            case "SUCCESS": {
                return <FaCheck size={13}/>;
            }
            case "FAILURE": {
                return (
                    <FaPlus size={15} style={{transform: "rotate(45deg)"}}/>
                );
            }
            default: {
                return <FaInfo size={13}/>
            }
        }
    };

    const getShortMessage = (message) => {
        let shortMessage = message.substring(0, MAX_NOTIFICATION_MESSAGE_LENGTH);
        shortMessage = shortMessage.concat("...");
        return shortMessage;
    };

    const hasMessageCorrectLength = (message) => {
        return message.length < MAX_NOTIFICATION_MESSAGE_LENGTH;
    };

    const getMoreButton = (item) => {
        return hasMessageCorrectLength(item.message) ? null : item.fullShow ? (
            <FaAngleDoubleUp color={'#858585'}/>
        ) : (
            <FaAngleDoubleDown color={'#858585'}/>
        );
    }

    return (
        <div
            style={{
                width: "33px",
                height: "33px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <button
                className={classes.notificationButton}
                onClick={() => {
                    setNotificationsOpen(true);
                }}
            >
                <Badge count={notificationCount} size="small" offset={[-3, 1]}>
                    <FaBell color={"#3A547F"} size={22}/>
                </Badge>
            </button>
            <Drawer
                title="Уведомления"
                onClose={onClose}
                open={notificationsOpen}
                visible={notificationsOpen}
                className={classes.container}
                width={window.innerWidth > 425 ? "35%" : window.innerWidth + "px"}
            >
                <List
                    dataSource={notifications}
                    loading={loading}
                    renderItem={(item, index) => (
                        <List.Item
                            key={index}
                            extra={
                                <a style={{marginLeft: '5px'}}
                                   onClick={() => dispatch(setFullShow(index))}>{getMoreButton(item)}</a>
                            }
                        >
                            <Skeleton avatar title={false} loading={false} active>
                                <List.Item.Meta
                                    avatar={
                                        <Badge dot={!item.isViewed} offset={[-23, -2]}>
                                            <div className={classes.itemIcon}>
                                                {getIconByItem(item)}
                                            </div>
                                        </Badge>
                                    }
                                    title={
                                        <ScrollContainer hideScrollbars={false} style={{maxHeight: "120px"}}>
                                            {(hasMessageCorrectLength(item.message) || item.fullShow) ? item.message : getShortMessage(item.message)}
                                        </ScrollContainer>
                                    }
                                    description={item.date}
                                />
                            </Skeleton>
                        </List.Item>
                    )}
                />
            </Drawer>
        </div>
    );
};

export default NotificationsPanel;
